import { render, staticRenderFns } from "./tagAdd.vue?vue&type=template&id=ecf2a1d8&scoped=true&"
import script from "./tagAdd.vue?vue&type=script&lang=js&"
export * from "./tagAdd.vue?vue&type=script&lang=js&"
import style0 from "./tagAdd.vue?vue&type=style&index=0&id=ecf2a1d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf2a1d8",
  null
  
)

export default component.exports